import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { BannerTransition as BannerTransitionType } from './banner/index.tsx';

const BannerTransition = lazyAfterPaint<typeof BannerTransitionType>(
	() =>
		import(/* webpackChunkName: "async-banner-eoc-transition" */ './banner').then(
			(module) => module.BannerTransition,
		),
	{
		entryFsSsrLiftImportToModule: true,
		// eslint-disable-next-line jira/entry-fs/restrict-shell-only-to-navigation-apps
		includeInShellOnlySsrBundle: true,
		entryFsSsrOverride: 'include',
	},
);

export const BannerTransitionAsync = () => (
	<Placeholder name="async-banner-eoc-transition" fallback={null}>
		<BannerTransition />
	</Placeholder>
);
